import React, { useRef, useState, useMemo, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { axInst } from "../../../Components/Login/Service";
import { Loader } from "rsuite";
import { useSelector } from "react-redux";

import retailSales from "../../../Artifacts/wsrPerformnaceDasboard/Retail Sales.png";
import TQP from "../../../Artifacts/wsrPerformnaceDasboard/TQP.png";
import Realization from "../../../Artifacts/wsrPerformnaceDasboard/Realization.png";
import btl from "../../../Artifacts/wsrPerformnaceDasboard/BTL adherence.png";
import beatplan from "../../../Artifacts/wsrPerformnaceDasboard/Beat Plan adherence.png";
import pvin from "../../../Artifacts/wsrPerformnaceDasboard/PVIN.png";
import digitalContribution from "../../../Artifacts/wsrPerformnaceDasboard/Digital contribution.png";
import vas from "../../../Artifacts/wsrPerformnaceDasboard/VAS.png";
import marketShare from "../../../Artifacts/wsrPerformnaceDasboard/Market share.png";
import AddImage from "../../../Artifacts/wsrPerformnaceDasboard/graph.png";

import { useNavigate } from "react-router-dom";
import { captureAndAddToPpt } from "../../captureAndAddToPpt.js";
import Swal from "sweetalert2";
import { FaCirclePlus, FaTrash } from "react-icons/fa6";

const ILMCVPerformanceApi = async (body) => {
  try {
    const response = await axInst.post("wsr/ilmcv_perfomance", body);
    return response.data || {};
  } catch (error) {
    console.error(error);
    return {};
  }
};

const PerformanceTable = () => {
  const navigate = useNavigate();
  const captureRef = useRef(null);
  const dropdownRef = useRef(null);
  const headingRef = useRef(null);
  const buttonRefs = useRef([]);
  const tableRefs = useRef([]);

  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");
  const [selOps, setSelOps] = useState({ Product_Line: [] });
  const [percentages, setPercentages] = useState({});
  const [targets, setTargets] = useState({});
  const [hiddenRows, setHiddenRows] = useState([]);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [hiddenRowCount, setHiddenRowCount] = useState("2");
  const [rows, setRows] = useState([
    {
      id: 1,
      dimension: "Retail Sales (Target: 80%)",
      valueKey: "RETAIL_NUM",
      targetKey: "RETAIL_DEN",
      target_per: {
        NORTH: 80,
        WEST: 80,
        EAST: 80,
        SOUTH: 80,
        OVERALL: 80,
      },
      imageUrl: retailSales,
    },
    {
      id: 2,
      dimension: "TQP (Target: 100%)",
      valueKey: "TQP_NUM",
      targetKey: "TQP_DEN",
      target_per: {
        NORTH: 100,
        WEST: 100,
        EAST: 100,
        SOUTH: 100,
        OVERALL: 100,
      },
      imageUrl: TQP,
    },

    {
      id: 3,
      dimension: "Realization",
      valueKey: "REALIZATION_NUM",
      targetKey: "REALIZATION_DEN",
      imageUrl: Realization,
      target_per: {
        // NORTH: 10,
        // WEST: 20,
        // EAST: 30,
        // SOUTH: 40,
        OVERALL: 78,
      },
    },
    {
      id: 4,
      dimension: "BTL Adherance (Target: 70%)",
      valueKey: "BTL_NUM",
      targetKey: "BTL_DEN",
      target_per: {
        NORTH: 70,
        WEST: 70,
        EAST: 70,
        SOUTH: 70,
        OVERALL: 70,
      },
      imageUrl: btl,
    },
    {
      id: 5,
      dimension: "Beat Plan Adherance (Target: 60%)",
      valueKey: "BEAT_PLAN_NUM",
      targetKey: "BEAT_PLAN_DEN",
      target_per: {
        NORTH: 60,
        WEST: 60,
        EAST: 60,
        SOUTH: 60,
        OVERALL: 60,
      },
      imageUrl: beatplan,
    },
    {
      id: 6,
      dimension: "PVIN utilization (Target 60%)",
      valueKey: "PVIN_NUM",
      targetKey: "PVIN_DEN",
      target_per: {
        NORTH: 60,
        WEST: 60,
        EAST: 60,
        SOUTH: 60,
        OVERALL: 60,
      },
      imageUrl: pvin,
    },
    {
      id: 7,
      dimension: "Digital contribution ( Target 15%)",
      valueKey: "DIGITAL_NUM",
      targetKey: "DIGITAL_DEN",
      target_per: {
        NORTH: 15,
        WEST: 15,
        EAST: 15,
        SOUTH: 15,
        OVERALL: 15,
      },
      imageUrl: digitalContribution,
    },
    {
      id: 8,
      dimension: "VAS Penetration ( Target 24%) ",
      valueKey: "VAS_PENETRATION",
      targetKey: "VAS_PENETRATION",
      target_per: {
        NORTH: 24,
        WEST: 24,
        EAST: 24,
        SOUTH: 24,
        OVERALL: 24,
      },
      imageUrl: vas,
    },
    {
      id: 9,
      dimension: "Market Share",
      valueKey: "MARKET_SHARE",
      targetKey: "MARKET_SHARE",
      target_per: {
        // NORTH: 80,
        // WEST: 75,
        // EAST: 90,
        // SOUTH: 85,
        OVERALL: 78,
      },
      imageUrl: marketShare,
    },
    {
      id: 10,
      dimension: "Dimension 1",
      valueKey: "DIMENTION1",
      targetKey: "DIMENTION1",
      target_per: {
        // NORTH: 80,
        // WEST: 75,
        // EAST: 90,
        // SOUTH: 85,
        OVERALL: 78,
      },
      imageUrl: AddImage,
    },
    {
      id: 11,
      dimension: "Dimension 2",
      valueKey: "DIMENTION2",
      targetKey: "DIMENTION2",
      target_per: {
        // NORTH: 80,
        // WEST: 75,
        // EAST: 90,
        // SOUTH: 85,
        OVERALL: 78,
      },
      imageUrl: AddImage,
    },
  ]);

  const fetchOptions = async () => {
    try {
      const response = await axInst.post("wsr/wsr_dropdown");
      const dropdownOptions = response.data || [];
      setOptions(dropdownOptions);

      // Set the first option as default
      if (dropdownOptions.length > 0) {
        // const defaultOption = dropdownOptions[0].key;
        const savedOption = localStorage.getItem("selectedDropdown");
        const defaultOption =
          savedOption ||
          (dropdownOptions.length > 0 ? dropdownOptions[0].key : "");
        setSelectedOption(defaultOption);
        setSelOps({ Product_Line: [defaultOption] });
      }
    } catch (error) {
      console.error("Error fetching dropdown options:", error);
    }
  };

  useEffect(() => {
    fetchOptions(); // Fetch options on component mount
  }, []);

  const handleSelectionChange = (event) => {
    const selection = event.target.value;
    setSelectedOption(selection);
    setSelOps({ Product_Line: [selection] });
  };

  const { data: filterdata, submitted } = useSelector(
    (state) => state.filtersOfftake
  );

  // Use react-query for data fetching
  const { data, isFetching, isError } = useQuery({
    queryKey: ["wsr", submitted, selOps.Product_Line],
    queryFn: () => ILMCVPerformanceApi({ ...filterdata, ...selOps }),
    refetchIntervalInBackground: true,
    cacheTime: 0,
    staleTime: 0,
  });

  if (isFetching) {
    return (
      <div className=" flex items-center justify-center w-full h-full">
        <Loader />
      </div>
    );
  }

  if (isError) {
    return <div>Error fetching data.</div>;
  }

  const calculatePercentage = (numerator, denominator) =>
    denominator > 0 ? ((numerator / denominator) * 100).toFixed(2) : "0";

  const regions = Object.keys(data).filter((region) => region !== "OVERALL");
  const handleValueChange = (e, region, row) => {
    const parentSpan = e.currentTarget;

    const fullText = parentSpan.innerText.trim();
    const parts = fullText.split("/");

    const actual = parseFloat(parts[0]) || 0;

    const percentageMatch = fullText.match(/(\d+(\.\d+)?)%/);
    const percentage = percentageMatch ? parseFloat(percentageMatch[1]) : 0;

    const targetSpan = parentSpan.querySelector('span[contentEditable="true"]');
    const target = targetSpan
      ? parseFloat(targetSpan.innerText.trim()) || 0
      : 0;

    let target_per;
    if (row.id >= 9) {
      const targetPerInput = document.querySelector(
        `input[data-region="${region}"][data-key="${row.targetKey}_TARGET"]`
      );
      target_per = targetPerInput
        ? parseFloat(targetPerInput.value.trim()) || 0
        : 0;
    } else {
      target_per = row.target_per[region];
    }

    const updatepercentage =
      target > 0 ? ((actual / target) * 100).toFixed(2) : 0;

    setPercentages((prev) => ({
      ...prev,
      [row.targetKey]: {
        ...prev[row.targetKey],
        [region]: updatepercentage,
      },
    }));

    let backgroundColorClass;
    if (updatepercentage === 0) {
      backgroundColorClass =
        percentage >= target_per ? "bg-green-500" : "bg-amber-200";
    } else {
      backgroundColorClass =
        updatepercentage >= target_per ? "bg-green-500" : "bg-amber-200";
    }
    const spanElement = e.currentTarget;

    if (spanElement && spanElement.tagName === "SPAN") {
      spanElement.classList.remove("bg-green-500", "bg-amber-200");

      spanElement.classList.add(backgroundColorClass);
    } else {
      console.warn("Span element not found or target is incorrect.");
    }

    // **Fix OVERALL percentage update**
    if (row.targetKey === "RETAIL_DEN" || row.targetKey === "TQP_DEN") {
      let newoverallTarget = 0;
      let newoverallActual = 0;

      regions.forEach((reg) => {
        const regionActual = parseFloat(
          document
            .querySelector(
              `span[data-region="${reg}"][data-row="${row.targetKey}"]`
            )
            ?.innerText.split("/")[0] || 0
        );
        const regionTarget = parseFloat(
          document
            .querySelector(
              `span[data-region="${reg}"][data-row="${row.targetKey}"] span[contentEditable="true"]`
            )
            ?.innerText.trim() || 0
        );

        newoverallActual += regionActual;
        newoverallTarget += regionTarget;
      });

      const newOverallPercentage =
        newoverallTarget > 0
          ? ((newoverallActual / newoverallTarget) * 100).toFixed(2)
          : 0;

      setPercentages((prev) => ({
        ...prev,
        [row.valueKey]: {
          ...prev[row.valueKey],
          OVERALL: newOverallPercentage,
        },
      }));

      const overallCell = document.querySelector(
        `span[data-region="OVERALL"][data-row="${row.targetKey}"]`
      );
      if (overallCell) {
        overallCell.classList.remove("bg-green-500", "bg-amber-200");
        overallCell.classList.add(
          newOverallPercentage >= row.target_per.OVERALL
            ? "bg-green-500"
            : "bg-amber-200"
        );

        overallCell.innerText = `${newoverallActual}/${newoverallTarget} (${newOverallPercentage}%)`;
      }
    }
    if (
      row.targetKey === "VAS_PENETRATION" ||
      row.targetKey === "MARKET_SHARE" ||
      row.targetKey === "DIMENTION1" ||
      row.targetKey === "DIMENTION2"
    ) {
      let newoverallSum = 0;

      regions.forEach((reg) => {
        const regionOverallSum = parseFloat(
          document
            .querySelector(
              `span[data-region="${reg}"][data-row="${row.targetKey}"]`
            )
            ?.innerText.split("/")[0] || 0
        );

        newoverallSum += regionOverallSum;
      });

      const newOverallPercentage = newoverallSum / regions.length;

      setPercentages((prev) => ({
        ...prev,
        [row.valueKey]: {
          ...prev[row.valueKey],
          OVERALL: newOverallPercentage,
        },
      }));

      const overallCell = document.querySelector(
        `span[data-region="OVERALL"][data-row="${row.targetKey}"]`
      );

      if (overallCell) {
        overallCell.classList.remove("bg-green-500", "bg-amber-200");
        overallCell.classList.add(
          newOverallPercentage >= row.target_per.OVERALL
            ? "bg-green-500"
            : "bg-amber-200"
        );

        overallCell.innerText = `${newOverallPercentage}%`;
      }
    }
  };

  const handleTargetUpdate = (region, newTarget, row) => {
    if (!row.target_per) {
      row.target_per = {};
    }
    row.target_per[region] = newTarget;

    // Get the actual value from the DOM or state
    const actualElement = document.querySelector(
      `[data-region="${region}"][data-row="${row.targetKey}"]`
    );

    if (!actualElement) {
      console.warn(
        `Element not found for region: ${region}, row: ${row.targetKey}`
      );
      return; // Exit function if element is not found
    }

    const actualValue = parseFloat(actualElement.innerText.trim()) || 0;

    // Call handleValueChange with updated values
    const mockEvent = {
      target: { innerText: actualValue.toString() },
      currentTarget: actualElement,
    };

    handleValueChange(mockEvent, region, row);
  };

  const handleTargetChange = (rowKey, region, value, row) => {
    setTargets((prev) => ({
      ...prev,
      [rowKey]: {
        ...prev[rowKey],
        [region]: value,
      },
    }));

    handleTargetUpdate(region, value, row);
  };

  const handleCaptureAndAddToPpt = () => {
    captureAndAddToPpt({
      element: captureRef.current,
      dropdownRef: dropdownRef.current,
      headingRef: headingRef.current,
      buttonRefs: buttonRefs.current,
      tableRefs: tableRefs.current,
      fileName: "Performance Dashboard",
    });
  };

  const targetKeys = [
    "RETAIL_DEN",
    "TQP_DEN",
    "REALIZATION_DEN_TARGET",
    "VAS_PENETRATION",
    "MARKET_SHARE_TARGET",
    "MARKET_SHARE",
    "DIMENTION1",
    "DIMENTION1_TARGET",
    "DIMENTION2",
    "DIMENTION2_TARGET",
  ];

  const handleSaveTarget = async () => {
    const updatedTargets = {};

    // Ensure all regions and target keys are initialized
    regions.forEach((region) => {
      if (!updatedTargets[region]) updatedTargets[region] = {};

      targetKeys.forEach((key) => {
        if (updatedTargets[region][key] === undefined) {
          updatedTargets[region][key] = 0; // Initialize missing keys
        }
      });
    });

    // Capture input values from inputs with data attributes
    document
      .querySelectorAll('input[type="text"][data-region][data-key]')
      .forEach((input) => {
        const region = input.getAttribute("data-region");
        const valueKey = input.getAttribute("data-key");

        if (!updatedTargets[region]) updatedTargets[region] = {};

        updatedTargets[region][valueKey] = parseFloat(input.value) || 0;
      });

    // Capture values from contentEditable spans
    document
      .querySelectorAll('span[contentEditable="true"]')
      .forEach((span) => {
        const regionElement = span.closest("[data-region]");
        const rowElement = span.closest("[data-row]");

        if (!regionElement || !rowElement) return; // Avoid null errors

        const region = regionElement.getAttribute("data-region");
        const valueKey = rowElement.getAttribute("data-row");

        if (!updatedTargets[region]) updatedTargets[region] = {};

        updatedTargets[region][valueKey] =
          span.innerText.match(/\d+(\.\d+)?/g)?.join("") || "0";
      });
    // Remove the 'OVERALL' key if it exists
    // delete updatedTargets.OVERALL;

    // Prepare payload
    const payload = {
      Product_Line: selOps.Product_Line,
      ...updatedTargets,
    };

    try {
      localStorage.setItem("selectedDropdown", selOps.Product_Line);
      const response = await axInst.put("wsr/ilmcv_perfomance", payload);
      // console.log("Response", response);

      if (
        response.status === 200 &&
        response.data?.message?.toLowerCase().includes("success")
      ) {
        await Swal.fire({
          title: response.data.message,
          icon: "success",
          draggable: true,
          confirmButtonText: "OK",
          didOpen: () => {
            document.querySelector(".swal2-confirm").style.backgroundColor =
              "green";
            document.querySelector(".swal2-confirm").style.color = "white";
          },
        });
        window.location.reload();
      } else {
        throw new Error("Unexpected response message");
      }
    } catch (error) {
      console.error("Error saving targets:", error);
      await Swal.fire({
        title: "Failed to save targets",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const toggleHiddenRows = () => {
    const hiddenRows = document.querySelectorAll("tr.hidden");

    if (hiddenRows.length > 0) {
      hiddenRows[0].classList.remove("hidden");
      setHiddenRowCount(hiddenRows.length - 1);
    }
  };

  const handleDeleteRow = (index) => {
    const row = document.querySelectorAll("tr")[index];

    if (row) {
      row.classList.add("hidden");

      setHiddenRows((prev) => [...prev, row]); // Store hidden rows in state
      setButtonDisabled(false); // Enable "Add Row" button since there is at least one hidden row
    }
  };

  return (
    <div ref={captureRef} style={{ backgroundColor: "#f2f5f9" }}>
      <div
        ref={headingRef}
        className="bg-[#2A5775] text-center text-white rounded-md font-bold mx-2 p-1 hidden"
      >
        Performance Dashboard
      </div>
      <div className="p-2 pt-1">
        <div className="my-1 flex justify-between">
          <div className="flex space-x-4 items-center">
            <div className="flex items-center space-x-2">
              <span className="w-4 h-4 bg-amber-200 block"></span>
              <span className="text-xs">Below Target</span>
            </div>
            <div className="flex items-center space-x-2">
              <span className="w-4 h-4 bg-green-500 block"></span>
              <span className="text-xs">Above Target</span>
            </div>
          </div>

          <div className="flex gap-2">
            <div ref={dropdownRef}>
              <select
                value={selectedOption}
                onChange={handleSelectionChange}
                className="border border-gray-300 text-[12px] rounded-md w-36 p-0.5"
              >
                {options.map((option, index) => (
                  <option key={index} value={option.key}>
                    {option.key}
                  </option>
                ))}
              </select>
            </div>

            <button
              onClick={toggleHiddenRows}
              disabled={hiddenRows.size === 0}
              title="Add Row"
              className="p-1 rounded-md flex items-center text-xs gap-1 bg-[#2A5775] text-white"
            >
              Add Row
            </button>
          </div>
        </div>
        <table className="table-auto w-full drilltable border-collapse border border-gray-400 text-sm">
          <thead>
            <tr className="bg-[#2A5775] text-center text-white">
              <th className="p-2 border border-gray-400 w-[400px]">
                Dimension
              </th>
              {regions.map((region) => (
                <th key={region} className="p-2 border border-l-gray-400 ">
                  {region}
                </th>
              ))}
              <th className="p-2 border border-gray-400 w-48">OVERALL</th>
              <th
                className="p-2 border border-gray-400"
                ref={(el) => {
                  tableRefs.current[57] = el;
                }}
              ></th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, rowIndex) => {
              let shouldDisplayRow =
                row.id === 10
                  ? Object.values(data).some((region) => region?.DIMENTION1) ||
                    data.forceShow10
                  : row.id === 11
                  ? Object.values(data).some((region) => region?.DIMENTION2) ||
                    data.forceShow11
                  : true;

              const overallActual = regions.reduce(
                (sum, region) => sum + (data[region]?.[row.valueKey] || 0),
                0
              );
              const overallTarget = regions.reduce(
                (sum, region) => sum + (data[region]?.[row.targetKey] || 0),
                0
              );

              const overallPercentage =
                row.id >= 8
                  ? Math.round(overallTarget / regions.length)
                  : calculatePercentage(overallActual, overallTarget);
              const overallStatus =
                overallPercentage >= parseFloat(row.target_per.OVERALL)
                  ? "bg-green-500"
                  : "bg-amber-200";

              return (
                <React.Fragment key={`row-${rowIndex}`}>
                  <tr
                    key={rowIndex}
                    className={`${
                      row.id === 3 || row.id === 6 || row.id === 8
                        ? "border-b-2 border-black"
                        : "border-b border-gray-400"
                    }${shouldDisplayRow ? "" : " hidden"}`}
                  >
                    <td className="p-[6px] border  border-b-gray-400 bg-[#D4E1EC] font-bold flex items-center gap-1 w-[400px] ">
                      <>
                        <img
                          src={row.imageUrl}
                          alt={row.dimension || "Image"}
                          className="h-9 w-12"
                        />
                        <span
                          className="whitespace-nowrap"
                          contentEditable={row.id > 9}
                          suppressContentEditableWarning={row.id > 9}
                        >
                          {row.dimension}
                        </span>
                      </>
                      {(row.id === 3 || row.id === 9 || row.id > 9) && (
                        <>
                          {/* <span className="text-[14px]"> </span> */}
                          {regions.map((region, regionIndex) => (
                            <div
                              key={regionIndex}
                              className="flex gap-1 items-center"
                            >
                              <label className="text-[13px]">
                                {region.charAt(0)}:
                              </label>

                              {/* <input
                                type="number"
                                defaultValue={
                                  data?.[region]?.[`${row.targetKey}_TARGET`] ??
                                  0
                                }
                                data-region={region}
                                data-key={`${row.targetKey}_TARGET`}
                                className="border border-black w-[30px] text-[12px] appearance-none 
      [&::-webkit-inner-spin-button]:appearance-none 
      [&::-webkit-outer-spin-button]:appearance-none 
      bg-[#D4E1EC] text-center rounded-md"
                                onBlur={(e) =>
                                  handleTargetChange(
                                    row.targetKey,
                                    region,
                                    parseFloat(e.target.value),
                                    row
                                  )
                                }
                              /> */}
                              <input
                                type="text"
                                defaultValue={
                                  data?.[region]?.[`${row.targetKey}_TARGET`] ??
                                  0
                                }
                                data-region={region}
                                data-key={`${row.targetKey}_TARGET`}
                                className="border border-black w-[30px] text-[12px] appearance-none 
    bg-[#D4E1EC] text-center rounded-md"
                                onInput={(e) => {
                                  e.target.value = e.target.value.replace(
                                    /[^0-9.]/g,
                                    ""
                                  );
                                }}
                                onBlur={(e) =>
                                  handleTargetChange(
                                    row.targetKey,
                                    region,
                                    parseFloat(e.target.value),
                                    row
                                  )
                                }
                              />
                            </div>
                          ))}
                          <div className="flex gap-1 items-center">
                            <label className="text-[13px]">O:</label>
                            <input
                              type="text"
                              defaultValue={
                                data?.OVERALL?.[`${row.targetKey}_TARGET`] ?? 0
                              }
                              // defaultValue={row.target_per.OVERALL}
                              data-region="OVERALL"
                              data-key={`${row.targetKey}_TARGET`}
                              className="border border-black w-[30px] text-[12px] appearance-none 
    bg-[#D4E1EC] text-center rounded-md"
                              onInput={(e) => {
                                e.target.value = e.target.value.replace(
                                  /[^0-9.]/g,
                                  ""
                                );
                              }}
                              onBlur={(e) =>
                                handleTargetChange(
                                  row.targetKey,
                                  "OVERALL",
                                  parseFloat(e.target.value),
                                  row
                                )
                              }
                            />
                          </div>
                        </>
                      )}
                    </td>

                    {regions.map((region) => {
                      const actual = data[region]?.[row.valueKey] || 0;
                      const target = data[region]?.[row.targetKey] || 0;

                      // const percentage = calculatePercentage(actual, target);
                      // const targetPercentage = row.target_per[region] || 0;

                      const dbKeys = {
                        3: "REALIZATION_DEN_TARGET",
                        9: "MARKET_SHARE_TARGET",
                        10: "DIMENTION1_TARGET",
                        11: "DIMENTION2_TARGET",
                      };

                      const targetPercentage =
                        row.id === 3 ||
                        row.id === 9 ||
                        row.id === 10 ||
                        row.id === 11
                          ? data[region]?.[dbKeys[row.id]] || 0
                          : row.target_per[region] || 0;

                      const percentage =
                        row.id >= 8
                          ? target
                          : calculatePercentage(actual, target);

                      const status =
                        percentage >= parseFloat(targetPercentage)
                          ? "bg-green-500"
                          : "bg-amber-200";

                      return (
                        <td
                          key={`${region}-${rowIndex}`}
                          className="p-[6px] border text-center border-b-gray-400 border-r-black"
                        >
                          {row.id === 1 || row.id === 2 ? (
                            <span
                              data-region={region}
                              data-row={row.targetKey}
                              className={`p-1 text-center flex items-center justify-center h-6 ${status}`}
                              onBlur={(e) => handleValueChange(e, region, row)}
                            >
                              <span>
                                {actual}/
                                <span
                                  contentEditable="true"
                                  suppressContentEditableWarning="true"
                                >
                                  {target}
                                </span>
                                (
                                {percentages[row.targetKey]?.[region] ||
                                  percentage}
                                %)
                              </span>
                            </span>
                          ) : row.id >= 8 ? (
                            <span
                              data-region={region}
                              data-row={row.targetKey}
                              className={`p-1 text-center flex items-center justify-center h-6 ${status}`}
                              contentEditable="true"
                              suppressContentEditableWarning="true"
                              onBlur={(e) => handleValueChange(e, region, row)}
                            >
                              {target}%
                            </span>
                          ) : (
                            <span
                              data-region={region}
                              data-row={row.targetKey}
                              className={`p-1 text-center flex items-center justify-center h-6 ${status}`}
                            >
                              {percentage}%
                            </span>
                          )}
                        </td>
                      );
                    })}

                    <td className="p-[6px] text-center border border-b-gray-400">
                      <span
                        data-region={"OVERALL"}
                        data-row={row.targetKey}
                        className={`p-2 text-center flex items-center justify-center h-6 ${overallStatus}`}
                      >
                        {row.id === 1 || row.id === 2 ? (
                          <span>
                            {overallActual}/<span>{overallTarget}</span>(
                            {overallPercentage}%)
                          </span>
                        ) : row.id >= 8 ? (
                          `${overallPercentage}%`
                        ) : (
                          `${overallPercentage}%`
                        )}
                      </span>
                    </td>
                    <td
                      className="p-[6px] text-center border border-b-gray-400"
                      ref={(el) => {
                        tableRefs.current[row.id + "11"] = el;
                      }}
                    >
                      <button
                        onClick={() => handleDeleteRow(row.id)}
                        className="text-red-600 hover:text-red-800"
                      >
                        <FaTrash />
                      </button>
                    </td>
                  </tr>
                </React.Fragment>
              );
            })}
          </tbody>
        </table>

        <section className="flex justify-center gap-5 mt-1">
          <button
            className="bg-[#2A5775] text-white font-semibold py-1 px-4 rounded hover:bg-[#2898e2] focus:outline-none focus:ring-2 focus:ring-blue-300 transition-all duration-300"
            ref={(el) => {
              buttonRefs.current[17] = el;
            }}
            onClick={handleSaveTarget}
          >
            Save Changes
          </button>
          <button
            className="bg-[#2A5775] text-white font-semibold py-1 px-4 rounded hover:bg-[#2898e2] focus:outline-none focus:ring-2 focus:ring-blue-300 transition-all duration-300"
            ref={(el) => {
              buttonRefs.current[11] = el;
            }}
            onClick={handleCaptureAndAddToPpt}
            title="Capture screenshot to add to PowerPoint"
          >
            Capture Screenshot
          </button>
          <button
            className="bg-[#2A5775] text-white font-semibold py-1 px-4 rounded hover:bg-[#2898e2] focus:outline-none focus:ring-2 focus:ring-blue-300 transition-all duration-300"
            ref={(el) => {
              buttonRefs.current[12] = el;
            }}
            title="WSR"
            onClick={() => navigate("/WSR")}
          >
            Weekly Sales Review
          </button>
          <button
            ref={(el) => {
              buttonRefs.current[14] = el;
            }}
            className="bg-[#2A5775] text-white font-semibold py-1 px-4 rounded hover:bg-[#2898e2] focus:outline-none focus:ring-2 focus:ring-blue-300 transition-all duration-300"
            title="Top 5 Applications TQP"
            onClick={() => navigate("/Tqp-LostCase")}
          >
            Top 5 Applications TQP
          </button>
          <button
            ref={(el) => {
              buttonRefs.current[13] = el;
            }}
            className="bg-[#2A5775] text-white font-semibold py-1 px-4 rounded hover:bg-[#2898e2] focus:outline-none focus:ring-2 focus:ring-blue-300 transition-all duration-300"
            title="WSR Metrics"
            onClick={() => navigate("/WSR-Metrics")}
          >
            Metrics
          </button>
          <button
            ref={(el) => {
              buttonRefs.current[15] = el;
            }}
            className="bg-[#2A5775] text-white font-semibold py-1 px-4 rounded hover:bg-[#2898e2] focus:outline-none focus:ring-2 focus:ring-blue-300 transition-all duration-300"
            title=" State wise Analysis of Retail & Offtake"
            onClick={() => navigate("/State-Offtake-Retails")}
          >
            State wise Analysis of Retail & Offtake
          </button>
        </section>
      </div>
    </div>
  );
};

export default PerformanceTable;
